// extracted by mini-css-extract-plugin
module.exports = {"Actions":"ResourceActionField_Actions__bPd1K"};